import {
  TypedFormControl,
  TypedFormGroup,
  type TypedFormArray,
} from '@principle-theorem/ng-shared';
import {
  BillingEntityRegistrationNumberType,
  IBillingEntityData,
  IPractice,
  type IBillingEntity,
  type IStaffer,
} from '@principle-theorem/principle-core/interfaces';
import { uid } from '@principle-theorem/shared';

export class BillingEntityFormGroup extends TypedFormGroup<IBillingEntity> {
  constructor() {
    super({
      uid: new TypedFormControl<string>(uid()),
      isDefault: new TypedFormControl<boolean>(false),
      displayName: new TypedFormControl<string>(''),
      entity: new TypedFormGroup<IBillingEntityData>({
        registrationNumberType:
          new TypedFormControl<BillingEntityRegistrationNumberType>(undefined),
        registrationNumber: new TypedFormControl<string>(''),
        address: new TypedFormControl<string>(''),
      }),
      deleted: new TypedFormControl<boolean>(false),
    });
  }

  get entity(): TypedFormGroup<IBillingEntityData> {
    return this.controls.entity as TypedFormGroup<IBillingEntityData>;
  }

  get registrationNumberType(): TypedFormControl<BillingEntityRegistrationNumberType> {
    return this.entity.controls
      .registrationNumberType as TypedFormControl<BillingEntityRegistrationNumberType>;
  }

  get registrationNumber(): TypedFormControl<string> {
    return this.entity.controls.registrationNumber as TypedFormControl<string>;
  }
}

export class BillingEntityControls {
  constructor(private formArray: TypedFormArray<IBillingEntity>) {}

  addControl(
    index?: number,
    options?: {
      emitEvent?: boolean;
    }
  ): void {
    const group = new BillingEntityFormGroup();
    if (!this.formArray.length) {
      group.controls.isDefault.setValue(true, { emitEvent: false });
    }
    const insertIndex = (index ?? this.formArray.length) + 1;
    this.formArray.insert(insertIndex, group, options);
  }

  removeControl(index: number): void {
    if (index < 1) {
      return;
    }
    this.formArray.removeAt(index);
  }

  reset(options?: { emitEvent?: boolean }): void {
    this.formArray.clear(options);
    this.addControl(0, options);
  }

  initBillingEntityControls(
    item: IStaffer | IPractice,
    options?: {
      emitEvent?: boolean;
    }
  ): void {
    this.reset(options);
    item.billingEntities?.map((_, index) =>
      index ? this.addControl(index, options) : undefined
    );
  }
}
